import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { useContent } from "@/lib/hooks";
import { formatDate } from "@/pages/Blog";

export default function BlogPost() {
  const { slug } = useParams();
  const { t, ml, lang } = useLang();
  const { data: post, isLoading, isError } = useContent(`/content/posts/${slug}`);

  if (isLoading) {
    return <div className="mx-auto max-w-3xl px-4 py-24 text-zinc-500">{t("common.loading")}</div>;
  }

  if (isError || !post) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-24 text-center">
        <p className="text-zinc-500">404</p>
        <Link to="/blog" className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-[#1A4BFF]">
          <ArrowLeft className="h-4 w-4 rtl:rotate-180" />
          {t("blog.back")}
        </Link>
      </div>
    );
  }

  return (
    <article data-testid="blog-post-page" className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
      <Link to="/blog" data-testid="blog-post-back" className="inline-flex items-center gap-2 text-sm font-bold text-[#1A4BFF] hover:underline">
        <ArrowLeft className="h-4 w-4 rtl:rotate-180" />
        {t("blog.back")}
      </Link>
      <h1 data-testid="blog-post-title" className="mt-6 font-heading text-3xl font-black tracking-tighter text-zinc-950 sm:text-4xl">
        {ml(post.title)}
      </h1>
      <p className="mt-4 flex items-center gap-1.5 text-sm text-zinc-500">
        <Calendar className="h-4 w-4" />
        {formatDate(post.created_at, lang)}
      </p>
      {post.image && <img src={post.image} alt={ml(post.title)} className="mt-8 h-72 w-full rounded-2xl object-cover sm:h-96" />}
      <div className="mt-8 space-y-5 text-base leading-relaxed text-zinc-700">
        {ml(post.content)
          .split("\n\n")
          .map((para, i) => (
            <p key={i}>{para}</p>
          ))}
      </div>
    </article>
  );
}
